import React from 'react';
import { FormattedMessage } from 'react-intl';

// components

import { Modal } from 'app-components';
import GIButton from '@common-components/button/GIButton';

// types

interface ExternalSiteModalProps {

    messageId: string;
    onCancel: () => void;
    onContinue: () => void;

}

const ExternalSiteModal = (props: ExternalSiteModalProps) => {

    const { messageId, onCancel, onContinue } = props;

    return (
        <Modal id='external_url_modal'>
            <Modal.Body>
                <p className={'large_txt'}>
                    <FormattedMessage id={messageId} />
                </p>
            </Modal.Body>
            <Modal.Controls>
                <GIButton id='cancel_btn' labelId='button.cancel' variant='secondary' onClickHandler={onCancel} />
                <GIButton id='continue_btn' labelId='button.continue' onClickHandler={onContinue} />
            </Modal.Controls>
        </Modal>
    );
};

export default ExternalSiteModal;